import React, {useState, useEffect, useRef} from "react";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {Toast} from "primereact/toast";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Link} from "react-router-dom";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import axios from "axios";
import {base, volunteers as volunteersEndpoint} from "../../api";
import {IoIosFemale} from "react-icons/io";
import {IoIosMale} from "react-icons/io";

export default function VolunteersDashboard() {
	const toast = useRef(null);
	const [volunteerList, setVolunteerList] = useState([]);
	const [showDialog, setShowDialog] = useState(false);
	const [selectedVolunteerDetail, setSelectedVolunteerDetail] = useState(null);

	// Function to delete a volunteer by ID
	const deleteVolunteer = async id => {
		try {
			await axios.delete(`${base}${volunteersEndpoint}${id}/`);
			toast.current.show({
				severity: "success",
				summary: "Deleted",
				detail: "Volunteer deleted",
				life: 3000,
			});
			setVolunteerList(volunteerList.filter(v => v.id !== id));
		} catch (error) {
			console.error("Delete failed", error);
			toast.current.show({
				severity: "error",
				summary: "Error",
				detail: "Delete failed",
				life: 3000,
			});
		}
	};

	useEffect(() => {
		const fetchVolunteers = async () => {
			try {
				const response = await axios.get(base + volunteersEndpoint);
				setVolunteerList(response.data);
			} catch (error) {
				console.error("Failed to fetch volunteers", error);
			}
		};
		fetchVolunteers();
	}, []);

	const accept = () => {
		toast.current.show({
			severity: "info",
			summary: "Confirmed",
			detail: "You have accepted",
			life: 3000,
		});
	};

	const reject = () => {
		toast.current.show({
			severity: "warn",
			summary: "Rejected",
			detail: "You have rejected",
			life: 3000,
		});
	};
	const removeItem = id => {
		confirmDialog({
			message: "Do you want to delete this record?",
			header: "Delete Confirmation",
			icon: "pi pi-info-circle",
			acceptClassName: "p-button-danger",
			accept: () => deleteVolunteer(id),
			reject,
		});
	};
	const nameBody = item => {
		return (
			<div className="d-flex align-items-start justify-content-start">
				<div className="d-grid me-3 mt-1">
					{item?.gender == "male" && (
						<>
							<Button
								rounded
								disabled
								severity="info"
								style={{width: "40px", height: "40px"}}
								className="p-0 d-flex justify-content-center align-items-center text-center">
								<IoIosMale className="fs-4" />
							</Button>
						</>
					)}
					{item?.gender == "female" && (
						<>
							<Button
								rounded
								disabled
								severity="warning"
								style={{width: "40px", height: "40px"}}
								className="p-0 d-flex justify-content-center align-items-center text-center">
								<IoIosFemale className="fs-4" />
							</Button>
						</>
					)}
				</div>
				<div className="d-grid my-1 text-truncate ">
					<span className="d-flex fw-bold text-primary">{item?.full_name}</span>
					<span className="d-flex small">{item?.project?.name}</span>
					<span className="d-flex small">{item?.phone_number}</span>
					<span className="d-flex small">{item?.email}</span>
					<span className="d-flex small">{item?.birth_date}</span>
				</div>
			</div>
		);
	};
	const authorizedPerson = item => {
		return (
			<div className="d-grid my-1 text-truncate ">
				<span className="d-flex">
					{item?.authorized_person_name ? item?.authorized_person_name : "Լրացված չէ"}{" "}
				</span>
				<span className="d-flex small">
					{item?.authorized_person_id_card ? item?.authorized_person_id_card : "Լրացված չէ"}{" "}
				</span>
				<span className="d-flex small">
					{item?.authorized_person_phone ? item?.authorized_person_phone : "Լրացված չէ"}{" "}
				</span>
				<span className="d-flex small">
					{item?.authorized_person_email ? item?.authorized_person_email : "Լրացված չէ"}{" "}
				</span>
				<span className="d-flex small">
					{item?.authorized_person_address ? item?.authorized_person_address : "Լրացված չէ"}{" "}
				</span>
			</div>
		);
	};

	const actionBody = item => {
		return (
			<div className="d-flex align-items-center justify-content-center">
				<Link to={"/volunteers/" + item.id} className="mx-1">
					<Button
						icon={"pi pi-pencil"}
						onClick={removeItem}
						severity="primary"
						rounded
						className="mx-1 opacity-50"
					/>
				</Link>

				<Button
					icon={"pi pi-trash"}
					onClick={() => removeItem(item.id)}
					severity="danger"
					rounded
					className="mx-1 opacity-50"
				/>
			</div>
		);
	};

	return (
		<div className="">
			<div className="col-12 text-end my-3">
				<Link to={"/volunteers/add_new"} className="btn btn-primary rounded-4">
					Ավելացնել կամավոր
				</Link>
			</div>
			<div className="card b-radius b-shadow p-3">
				<DataTable
					value={volunteerList}
					rowHover
					onRowClick={e => {
						setSelectedVolunteerDetail(e.data);
						setShowDialog(true);
					}}>
					<Column header="Կամավորներ" body={nameBody} className="col-4"></Column>
					<Column header="Լիազոր" body={authorizedPerson} className="col-4"></Column>
					<Column header="Գործողություններ" body={actionBody} className="col-1"></Column>
				</DataTable>
			</div>
			<Dialog
				header="Volunteer Details"
				visible={showDialog}
				style={{width: "50vw"}}
				modal
				onHide={() => setShowDialog(false)}>
				{selectedVolunteerDetail && (
					<div className="p-fluid">
						<div>
							<strong>Full Name:</strong> {selectedVolunteerDetail.full_name}
						</div>

						<div>
							<strong>Project:</strong> {selectedVolunteerDetail.project?.name}
						</div>
						<div>
							<strong>Phone:</strong> {selectedVolunteerDetail.phone_number}
						</div>
						<div>
							<strong>Email:</strong> {selectedVolunteerDetail.email}
						</div>
						<div>
							<strong>Birth Date:</strong> {selectedVolunteerDetail.birth_date}
						</div>
						<div>
							<strong>Address:</strong> {selectedVolunteerDetail.address}
						</div>
						<hr />
						<div>
							<strong>Authorized Person Name:</strong>{" "}
							{selectedVolunteerDetail.authorized_person_name}
						</div>
						<div>
							<strong>Authorized Person ID:</strong>{" "}
							{selectedVolunteerDetail.authorized_person_id_card ||
								selectedVolunteerDetail.authorized_person_id}
						</div>
						<div>
							<strong>Authorized Person Phone:</strong>{" "}
							{selectedVolunteerDetail.authorized_person_phone}
						</div>
						<div>
							<strong>Authorized Person Email:</strong>{" "}
							{selectedVolunteerDetail.authorized_person_email}
						</div>
						<div>
							<strong>Authorized Person Address:</strong>{" "}
							{selectedVolunteerDetail.authorized_person_address}
						</div>
					</div>
				)}
			</Dialog>
			<Toast ref={toast} />
			<ConfirmDialog />
		</div>
	);
}
